// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"4bbf1903","164":"0d3a4233","246":"2bb52f6f","255":"09bfe6ea","531":"37aa05a0","844":"347fc3bf","960":"79e8fa85"}[chunkId] + ".chunk.css";
};